export default "__VITE_ASSET__D7KCuP6s__"